import moment from 'moment';
import Resources from '../../helpers/resources';
import { mapSelectedActivitiesToReq } from '../../helpers/resources-helper';

export async function assignActivityToAllStudents(
  studentAssignments,
  classroomId,
  groupId,
  courseId,
  startDatePreference,
  dueDatePreference
) {
  return Resources.assign
    .post({ classroomId, groupId })
    .withBody({
      courseId,
      startDate:
        startDatePreference &&
        moment(
          `${startDatePreference[0]} ${startDatePreference[1]}`
        ).toISOString(),
      dueDate:
        dueDatePreference &&
        moment(`${dueDatePreference[0]} ${dueDatePreference[1]}`).toISOString(),
      hasDueDate: dueDatePreference !== undefined,
      ...mapSelectedActivitiesToReq(studentAssignments)
    })
    .send()
    .then(
      () => true,
      () => false
    );
}
export const getStudents = (ljId, data, classrooms) => {
  const assignmentStatuses = data.length
    ? data.filter((d) => d.learningJourneyId === ljId && d.needsAttention)
    : [];
  const students = [];
  if (assignmentStatuses.length > 0) {
    const studentIds = assignmentStatuses.map((val) => val.studentProfileId);
    for (const classroom of classrooms) {
      for (const group of classroom.groups) {
        for (const student of group.students) {
          if (
            studentIds.indexOf(student.id) !== -1 &&
            !students.find((s) => s.id === student.id)
          ) {
            students.push({
              id: student.id,
              firstName: student.firstName,
              lastName: student.lastName
            });
          }
          if (students.length === assignmentStatuses.length) {
            return students;
          }
        }
      }
    }
  }
  return students;
};



// WEBPACK FOOTER //
// ./components/activity-header/util.js